exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ProfileCard-227d4792{text-align:center}.ProfileCard-227d4792 .top-6fc595b5{position:relative;overflow:hidden}.ProfileCard-227d4792 .topBgImg-2b8ab24d{position:absolute;top:-15px;right:-15px;bottom:-15px;left:-15px;filter:blur(10px);z-index:0}.ProfileCard-227d4792 .profileImg-0c354e1f{display:block;margin:15px auto;position:relative;z-index:1;border:2px solid #FFF}.ProfileCard-227d4792 .bottom-110cca18{padding:20px 20px}.ProfileCard-227d4792 .userName-c23232a2{margin-bottom:5px}.ProfileCard-227d4792 .userLoc-259a3b60{color:#757575}.ProfileCard-227d4792 .userDesc-be870c5c{margin-top:10px}.ProfileCard-227d4792 .manageAccount-1c5986b1{display:inline-block;margin-top:30px}\n", ""]);

// Exports
exports.locals = {
	"ProfileCard": "ProfileCard-227d4792",
	"top": "top-6fc595b5",
	"topBgImg": "topBgImg-2b8ab24d",
	"profileImg": "profileImg-0c354e1f",
	"bottom": "bottom-110cca18",
	"userName": "userName-c23232a2",
	"userLoc": "userLoc-259a3b60",
	"userDesc": "userDesc-be870c5c",
	"manageAccount": "manageAccount-1c5986b1"
};